module.exports = __webpack_public_path__ + "static/media/whitehandset.eef248e6.svg";